<template>
<div class="chapter">
<div class="inner_page">
<p class="img"><img alt="art" src="images/Art_Pfma.jpg"/></p>
<p class="p1"><strong>Oscar Casares</strong> was born and raised in Brownsville, Texas. His stories have appeared in <em>The Threepenny Review, Northwest Review, Colorado Review,</em> and <em>The Iowa Review.</em> A graduate of the Iowa Writers' Workshop, he has received the Dobie-Paisano Fellowship from the Texas Institute of Letters and the University of Texas, and the James Michener Award from the Copernicus Society of America. He lives in San Antonio and is working on his first novel.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brownsville_fore-1.vue?241e263a